import { create } from 'zustand';

// Coordinates between row-click (trigger) and the page-level slide panel
// (consumer). Stores only the id; the panel re-fetches via usePatientInquiryQuery
// so the reply mutation shows server-truth via a cache patch.
//
// `isComposing` (additional-reply textarea revealed) is added in Slice 4 with the
// reply flow; Slice 2 keeps the store to open/close only.
interface PatientInquiryDetailState {
  openId: number | null;
  // A reply draft is being composed — closing the panel would discard it, so a
  // confirm is shown first (unsaved-changes guard).
  dirty: boolean;
  showDiscard: boolean;
  open: (id: number) => void;
  // Hard close — clears the panel and resets the guard flags.
  close: () => void;
  setDirty: (dirty: boolean) => void;
  // Guarded close: dirty → open the discard confirm; clean → close immediately.
  requestClose: () => void;
  cancelDiscard: () => void;
}

export const usePatientInquiryDetailStore = create<PatientInquiryDetailState>((set, get) => ({
  openId: null,
  dirty: false,
  showDiscard: false,
  open: (id) => set({ openId: id, dirty: false, showDiscard: false }),
  close: () => set({ openId: null, dirty: false, showDiscard: false }),
  setDirty: (dirty) => set({ dirty }),
  requestClose: () => {
    if (get().dirty) set({ showDiscard: true });
    else set({ openId: null, dirty: false, showDiscard: false });
  },
  cancelDiscard: () => set({ showDiscard: false }),
}));
